import EditInvoiceForm from 'src/components/Forms/EditInvoiceForm';
import { MODALS } from 'src/models/ModalModel';
import ModalBase from 'src/components/Modals/ModalBase';
import { MODALS_SIZE } from 'src/models/modal';
import { FORM } from 'src/constants/Form';

const EditInvoiceModal = () => (
  <ModalBase
    name={MODALS.editInvoice}
    size={MODALS_SIZE.large}
    form={FORM.get_invoice}>
    <EditInvoiceForm />
  </ModalBase>
);

export default EditInvoiceModal;
